export const iframeFeatureAllowList = [
    'fullscreen',
]
